export const pokedexGen6 = {
  "pokedex650": "Igamaro",
  "pokedex651": "Igastarnish",
  "pokedex652": "Brigaron",
  "pokedex653": "Fynx",
  "pokedex654": "Rutena",
  "pokedex655": "Fennexis",
  "pokedex656": "Froxy",
  "pokedex657": "Amphizel",
  "pokedex658": "Quajutsu",
  "pokedex659": "Scoppel",
  "pokedex660": "Grebbit",
  "pokedex661": "Dartiri",
  "pokedex662": "Dartignis",
  "pokedex663": "Fiaro",
  "pokedex664": "Purmel",
  "pokedex665": "Puponcho",
  "pokedex666": "Vivillon",
  "pokedex667": "Leufeo",
  "pokedex668": "Pyroleo",
  "pokedex669": "Flabébé",
  "pokedex670": "Floette",
  "pokedex671": "Florges",
  "pokedex672": "Mähikel",
  "pokedex673": "Chevrumm",
  "pokedex674": "Pam‑Pam",
  "pokedex675": "Pandagro",
  "pokedex676": "Coiffwaff",
  "pokedex677": "Psiau",
  "pokedex678": "Psiaugon",
  "pokedex679": "Gramokles",
  "pokedex680": "Duokles",
  "pokedex681": "Durengard",
  "pokedex682": "Parfi",
  "pokedex683": "Parfinesse",
  "pokedex684": "Flauschling",
  "pokedex685": "Sabbaione",
  "pokedex686": "Iscalar",
  "pokedex687": "Calamanero",
  "pokedex688": "Bithora",
  "pokedex689": "Thanathora",
  "pokedex690": "Algitt",
  "pokedex691": "Tandrak",
  "pokedex692": "Scampisto",
  "pokedex693": "Wummer",
  "pokedex694": "Eguana",
  "pokedex695": "Elezard",
  "pokedex696": "Balgoras",
  "pokedex697": "Monargoras",
  "pokedex698": "Amarino",
  "pokedex699": "Amagarga",
  "pokedex700": "Feelinara",
  "pokedex701": "Resladero",
  "pokedex702": "Dedenne",
  "pokedex703": "Rocara",
  "pokedex704": "Viscora",
  "pokedex705": "Viscargot",
  "pokedex706": "Viscogon",
  "pokedex707": "Clavion",
  "pokedex708": "Paragoni",
  "pokedex709": "Trombork",
  "pokedex710": "Irrbis",
  "pokedex711": "Pumpdjinn",
  "pokedex712": "Arktip",
  "pokedex713": "Arktilas",
  "pokedex714": "eF-eM",
  "pokedex715": "UHaFnir",
  "pokedex716": "Xerneas",
  "pokedex717": "Yveltal",
  "pokedex718": "Zygarde",
  "pokedex719": "Diancie",
  "pokedex720": "Hoopa",
  "pokedex721": "Volcanion"
};